import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'

import Home from '../views/Home.vue'
import Company from '../views/Company.vue'

import Admin from '../views/Admin.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Index',
    component: Index
}, {
    path: '/home',
    name: 'Home',
    component: Home,
    children: [{
        path: '/hello',
        component: () => import('../views/Hello.vue')
    },   {
        path: '/reportDisputes',
        component: () => import('../views/order/ReportDisputes.vue')
    },  {
        path: '/surveyOrder',
        component: () => import('../views/order/SurveyOrder.vue')
    }, {
        path: '/operationRecord',
        component: () => import('../views/report/OperationRecord.vue')
    },{
        path: '/companyInfo',
        component: () => import('../views/system/CompanyInfo.vue')
    }, {
        path: '/role',
        component: () => import('../views/system/Role.vue')
    }, {
        path: '/printSetUp',
        component: () => import('../views/system/PrintSetUp.vue')
    }]
}, {
    path: '/Login',
    name: 'Login',
    component: () =>
        import( /* webpackChunkName: "about" */ '../views/Login.vue'),
    meta: {
        title: '登录'
    }
}, {
    path: '/Company',
    name: 'Company',
    component: Company
}, {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    children: [{
        path: 'hello',
        component: () => import('../views/Hello.vue'),
        meta: {
            title: '乌鸦背调-开发运营系统'
        },
    }, {
        path: 'tenantAdmin',
        component: () => import('../views/TenantAdmin.vue')
    },{
        path: 'disputesAdmin',
        component: () => import('../views/DisputesAdmin.vue')
    }, {
        path: 'userAdmin',
        component: () => import('../views/UserAdmin.vue')
    }, {
        path: 'tmplAdmin',
        component: () => import('../views/TmplAdmin.vue')
    }]
}
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router